export enum CloudMessagingPermission {
  requestable = "REQUESTABLE",
  authorized = "AUTHORIZED",
  denied = "DENIED",
  provisionalAuthorized = "PROVISIONALAUTHORIZED",
}
